import SEO from "@/components/SEO";

const PolitiqueConfidentialitePage = () => {
  return (
    <>
      <SEO
        title="Politique de Confidentialité | Lenvia"
        description="Politique de confidentialité et gestion des données personnelles chez Lenvia."
      />

      <div className="pt-28 pb-20">
        <div className="lenvia-container max-w-4xl">
          <h1 className="font-heading text-4xl md:text-5xl font-bold text-white mb-10">
            Politique de <span className="gradient-text">confidentialité</span>
          </h1>

          <div className="space-y-8 text-slate-400">
            <section className="glass-card p-6 md:p-8">
              <h2 className="text-xl font-semibold text-white mb-4">1. Collecte des données</h2>
              <p className="mb-4">
                Lenvia est amenée à collecter des données personnelles via les formulaires présents sur le site :
              </p>
              <ul className="list-disc pl-5 space-y-2 mb-4 text-slate-300">
                <li>Nom</li>
                <li>Email professionnel</li>
                <li>Message / contexte de la demande</li>
              </ul>
              <p>
                Ces données sont strictement nécessaires pour répondre à votre demande.
              </p>
            </section>

            <section className="glass-card p-6 md:p-8">
              <h2 className="text-xl font-semibold text-white mb-4">2. Utilisation des données</h2>
              <p className="mb-4">
                Les données collectées sont utilisées uniquement pour :
              </p>
              <ul className="list-disc pl-5 space-y-2 mb-4 text-slate-300">
                <li>Répondre aux demandes de contact</li>
                <li>Échanger dans un cadre professionnel</li>
              </ul>
              <p>
                Aucune donnée n'est utilisée à des fins commerciales sans consentement.
              </p>
            </section>

            <section className="glass-card p-6 md:p-8">
              <h2 className="text-xl font-semibold text-white mb-4">3. Conservation des données</h2>
              <p className="mb-4">
                Les données sont conservées pour une durée strictement nécessaire au traitement de la demande.
              </p>
              <p>
                Elles peuvent être supprimées sur simple demande.
              </p>
            </section>

            <section className="glass-card p-6 md:p-8">
              <h2 className="text-xl font-semibold text-white mb-4">4. Sécurité</h2>
              <p>
                Lenvia met en œuvre des mesures techniques et organisationnelles afin de garantir la sécurité et la confidentialité des données.
              </p>
            </section>

            <section className="glass-card p-6 md:p-8">
              <h2 className="text-xl font-semibold text-white mb-4">5. Partage des données</h2>
              <p>
                Les données ne sont ni vendues, ni louées, ni transmises à des tiers.
              </p>
            </section>

            <section className="glass-card p-6 md:p-8">
              <h2 className="text-xl font-semibold text-white mb-4">6. Vos droits</h2>
              <p className="mb-4">
                Conformément au RGPD, vous disposez des droits suivants :
              </p>
              <ul className="list-disc pl-5 space-y-2 mb-4 text-slate-300">
                <li>Droit d'accès</li>
                <li>Droit de rectification</li>
                <li>Droit de suppression</li>
                <li>Droit d'opposition</li>
              </ul>
              <p>
                Vous pouvez exercer ces droits à l'adresse suivante :{" "}
                <a href="mailto:contact@lenvia.eu" className="text-lenvia-blue hover:text-white transition-colors">
                  contact@lenvia.eu
                </a>
              </p>
            </section>

            <section className="glass-card p-6 md:p-8">
              <h2 className="text-xl font-semibold text-white mb-4">7. Contact</h2>
              <p>
                Pour toute question relative à la protection des données :{" "}
                <a href="mailto:contact@lenvia.eu" className="text-lenvia-blue hover:text-white transition-colors">
                  contact@lenvia.eu
                </a>
              </p>
            </section>
          </div>
        </div>
      </div>
    </>
  );
};

export default PolitiqueConfidentialitePage;
